import { config } from "JS/Config";
import { RecommendationBatch, Recommendations } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export class RecommendationService extends BaseService {
    getRecommendedAudios = () =>
        this.ngCall<Recommendations[]>(
            "get",
            appConstants.ngEndpoints.getRecommendedMedia(config.user.memberId),
            {
                params: {
                    contentType: "MP3",
                },
            },
        );

    getRecommendationBatch(): Promise<RecommendationBatch> {
        return this.ngCall<RecommendationBatch>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.recommendations.bucketName,
                    filePath: config.s3.recommendations.key,
                },
            },
        ).then((response) => response.data);
    }
}
